import React, { useState } from 'react';
import { motion } from 'framer-motion';

const FinalGateway = () => {
  const [form, setForm] = useState({ name: '', email: '' });
  const [submitted, setSubmitted] = useState(false);
  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });
  const handleSubmit = e => { e.preventDefault(); setSubmitted(true); };

  return (
    <section id="anmelden" className="relative py-32 overflow-hidden bg-dark border-t border-gold/20">
      {/* Pulsing Gold Frame */}
      <motion.div
        animate={{ opacity: [0.3, 0.7, 0.3], scale: [1, 1.005, 1] }}
        transition={{ duration: 4, repeat: Infinity, ease: 'easeInOut' }}
        className="absolute inset-6 md:inset-12 pointer-events-none rounded-sm"
        style={{
          border: '1px solid rgba(212,175,55,0.25)',
          boxShadow: '0 0 60px rgba(212,175,55,0.08), inset 0 0 60px rgba(212,175,55,0.04)',
        }}
      />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_50%,rgba(212,175,55,0.07)_0%,transparent_65%)]" />

      <div className="relative z-10 max-w-3xl mx-auto px-6 text-center">
        <motion.p
          initial={{ opacity: 0, letterSpacing: '0.1em' }}
          whileInView={{ opacity: 1, letterSpacing: '0.4em' }}
          viewport={{ once: true }}
          transition={{ duration: 1.5 }}
          className="text-gold uppercase text-xs font-semibold mb-8"
          style={{ textShadow: '0 0 20px rgba(212,175,55,0.6)' }}
        >
          Das Portal · 17. April 2026
        </motion.p>

        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
          className="text-5xl md:text-7xl font-serif text-cream leading-tight mb-8"
        >
          Du bist eingeladen zur{' '}
          <span
            className="block italic text-transparent bg-clip-text bg-gold-gradient mt-2"
            style={{ filter: 'drop-shadow(0 0 20px rgba(212,175,55,0.3))' }}
          >
            LOVE SHIFT
          </span>
          Masterclass.
        </motion.h2>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4 }}
          className="text-lg text-cream/65 font-light leading-relaxed mb-6"
        >
          In 90 Minuten erhältst du die Werkzeuge, um deine Muster zu entschlüsseln, deine feminine
          Energie zu erwecken und magnetisch ganz zu werden – ohne zu jagen, ohne zu warten,
          ohne dich zu verlieren.
        </motion.p>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.6 }}
          className="text-xl font-serif text-cream italic mb-14"
        >
          Bist du bereit, dein eigenes Kapitel zu schreiben?
        </motion.p>

        {submitted ? (
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            className="flex flex-col items-center gap-6 py-12"
          >
            <div
              className="w-20 h-20 rounded-full border-2 border-gold flex items-center justify-center text-gold text-3xl"
              style={{ boxShadow: '0 0 40px rgba(212,175,55,0.4)' }}
            >
              ✓
            </div>
            <h3 className="text-3xl font-serif text-cream">Dein Platz ist reserviert.</h3>
            <p className="text-cream/60 font-light max-w-md">
              Schau in dein Postfach. Jennifer schickt dir alles, was du brauchst, um dich auf
              deine Transformation vorzubereiten.
            </p>
          </motion.div>
        ) : (
          <motion.form
            onSubmit={handleSubmit}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.5 }}
            className="space-y-4 max-w-md mx-auto"
          >
            <input
              type="text"
              name="name"
              value={form.name}
              onChange={handleChange}
              placeholder="Dein Vorname"
              required
              className="w-full bg-white/5 border border-white/10 text-cream placeholder:text-cream/30 px-6 py-4 focus:outline-none focus:border-gold/60 transition-colors duration-500 font-light text-base rounded-sm"
            />
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              placeholder="Deine beste E-Mail-Adresse"
              required
              className="w-full bg-white/5 border border-white/10 text-cream placeholder:text-cream/30 px-6 py-4 focus:outline-none focus:border-gold/60 transition-colors duration-500 font-light text-base rounded-sm"
            />
            <motion.button
              type="submit"
              whileHover={{ scale: 1.04, boxShadow: '0 0 60px rgba(212,175,55,0.7), 0 0 120px rgba(212,175,55,0.3)' }}
              whileTap={{ scale: 0.97 }}
              className="w-full px-10 py-5 bg-gold-gradient text-dark font-bold uppercase tracking-widest text-sm transition-all duration-700"
              style={{ boxShadow: '0 0 30px rgba(212,175,55,0.4)', borderRadius: '2px' }}
            >
              Meinen Platz sichern →
            </motion.button>
            <p className="text-xs text-cream/30 tracking-widest">
              Kostenlos · Kein Spam · Jederzeit abmeldbar
            </p>
          </motion.form>
        )}
      </div>
    </section>
  );
};

export default FinalGateway;